module.exports = __webpack_public_path__ + "static-v-shop/1778679664705/img/logo_naranja.00996b70.png";